export var EtlSourceKey;
(function (EtlSourceKey) {
    EtlSourceKey["DYNAMICS_CRM"] = "dynamics-crm";
    EtlSourceKey["BRIGHTWORK"] = "brightwork";
    EtlSourceKey["SHAREPOINT"] = "sharepoint";
})(EtlSourceKey || (EtlSourceKey = {}));
export var CanonicalType;
(function (CanonicalType) {
    CanonicalType["PARTY"] = "party";
    CanonicalType["ORGANIZATION"] = "organization";
    CanonicalType["WORK_ITEM"] = "workItem";
    CanonicalType["ACTIVITY"] = "activity";
    CanonicalType["DOCUMENT"] = "document";
    CanonicalType["COMMENT"] = "comment";
    CanonicalType["DEAL"] = "deal";
})(CanonicalType || (CanonicalType = {}));
export var EtlRunStatus;
(function (EtlRunStatus) {
    EtlRunStatus["IDLE"] = "idle";
    EtlRunStatus["RUNNING"] = "running";
    EtlRunStatus["SUCCEEDED"] = "succeeded";
    EtlRunStatus["FAILED"] = "failed";
})(EtlRunStatus || (EtlRunStatus = {}));
/**
 * Normalised project/activity health rating (RAG). Source systems expose many
 * vocabularies — `'Green' | 'Yellow' | 'Red'`, `'Amber'`, `'On Track' | 'At
 * Risk' | 'Off Track'`, numeric scores — so each mapper translates its source
 * labels into this canonical enum, letting downstream features read health
 * source-agnostically. `'Yellow'` and `'Amber'` both map to {@link RagStatus.Amber}.
 */
export var RagStatus;
(function (RagStatus) {
    RagStatus["Green"] = "green";
    RagStatus["Amber"] = "amber";
    RagStatus["Red"] = "red";
})(RagStatus || (RagStatus = {}));
/**
 * Normalised escalation depth — how far up the org / delivery hierarchy a work
 * item has been raised. Sources expose their own ladders (BrightWork issues:
 * `'Project' | 'Program' | 'Portfolio'`); each mapper normalises its labels
 * onto this ordered scale so escalation is comparable across integrations
 * instead of being a source-specific string. Ordered `None < Low < Medium <
 * High`; `None` (or an absent field) means "not escalated".
 */
export var EscalationLevel;
(function (EscalationLevel) {
    EscalationLevel["None"] = "none";
    EscalationLevel["Low"] = "low";
    EscalationLevel["Medium"] = "medium";
    EscalationLevel["High"] = "high";
})(EscalationLevel || (EscalationLevel = {}));
